export enum SystemInoperabilityActionsEnum {
  ADMIN_GET_SISTEM_INOPERABILITY_LIST = 'ADMIN_GET_SISTEM_INOPERABILITY_LIST',
  ADMIN_SET_SISTEM_INOPERABILITY_LIST = 'ADMIN_SET_SISTEM_INOPERABILITY_LIST',
  ADMIN_SET_SISTEM_INOPERABILITY_LIST_ORDER = 'ADMIN_SET_SISTEM_INOPERABILITY_LIST_ORDER',
  ADMIN_GET_SISTEM_INOPERABILITY_LIST_NEXT_PAGE = 'ADMIN_GET_SISTEM_INOPERABILITY_LIST_NEXT_PAGE',
}
